<script setup lang="ts">
import { computed } from 'vue';
import { EyeIcon, PauseIcon, PlayIcon, XIcon } from '@lucide/vue';
import { Button } from '@/components/ui/button';
import { useObservation } from '@/composables/useObservation';

const observation = useObservation();
const detail = computed(() => {
  if (observation.restoring.value) return 'Возвращаем вашу таблицу…';
  if (observation.error.value) return observation.error.value;
  if (observation.paused.value) return 'Пауза · можно осмотреть таблицу';
  switch (observation.status.value) {
    case 'disconnected': return 'Связь потеряна · переподключаемся…';
    case 'offline': return 'Вкладка сотрудника отключена · ждём возвращения';
    case 'waiting': return 'Сотрудник сейчас вне таблицы';
    case 'connecting': return 'Подключаемся к таблице…';
    case 'forbidden': return 'Нет доступа к наблюдению';
    default: return 'Ячейки, выделение и ввод в реальном времени';
  }
});
</script>

<template>
  <div v-if="observation.active.value" class="flex min-h-12 shrink-0 items-center gap-2 border-b border-border bg-muted/70 px-2 sm:px-3" data-testid="observation-banner">
    <EyeIcon class="hidden size-4 shrink-0 sm:block" :style="{ color: observation.color.value }" />
    <div class="min-w-0 flex-1" role="status">
      <p class="truncate text-[12px] font-medium">Наблюдаете за {{ observation.name.value }}</p>
      <p class="truncate text-[11px] text-muted-foreground" :title="detail">{{ detail }}</p>
    </div>
    <Button variant="outline" size="sm" class="h-8 w-28 shrink-0 text-[12px]" :disabled="observation.restoring.value" @click="observation.paused.value ? observation.resume() : observation.pause()">
      <PlayIcon v-if="observation.paused.value" class="size-3.5" />
      <PauseIcon v-else class="size-3.5" />
      {{ observation.paused.value ? 'Продолжить' : 'Пауза' }}
    </Button>
    <Button variant="ghost" size="icon" class="size-8 shrink-0" aria-label="Завершить наблюдение" data-tip="Завершить наблюдение и вернуться к своей таблице" :disabled="observation.restoring.value" @click="observation.stop()">
      <XIcon class="size-4" />
    </Button>
  </div>
</template>
